$(document).ready(function() {
  
  
  $('.zip-code-sec.z-step-2').addClass('h-hide');   
    $('.zip-code-sec.z-step-3').addClass('h-hide');

//     $('#zip_check_1').click(function () {
//       $('.zip-code-sec.z-step-2').removeClass('h-hide');
//       $('.cal_data').addClass('h-hide');
//       $('.zip-code-sec.z-step-1').addClass('h-hide');
      
//     });
  
  
 
  
  		
  
  
  	$('#zip_check_2').click(function () {

      $('.zip-code-sec.z-step-2').addClass('h-hide');
      $('.zip-code-sec.z-step-3').removeClass('h-hide');
      $('#message-delivery').hide();


    });
  
  
  	$('.baack-link-date').click(function () {

      $('.zip-code-sec.z-step-2').removeClass('h-hide');
      $('.zip-code-sec.z-step-3').addClass('h-hide');
      $('#message-delivery').show();

    });
  
  
  
  	$('#zip_check_3').click(function () {
	
      $('.zip-code-sec.z-step-1').addClass('h-hide');
      $('.zip-code-sec.z-step-2').addClass('h-hide');
      $('.zip-code-sec.z-step-3').addClass('h-hide');
      $('#cart').removeClass('h-hide');
      $('.cal_data').removeClass('h-hide');
      
      $('#message-delivery').hide();

    });

  
  $('.mobile-menu-toggle').on('click', function() {
    $('.mobile-menu').stop().animate({
      left: 0
    }, 400, function() {
      $('body').addClass('overflow-hidden');
    });
    return false;
  });
  $('.mobile-menu-close').on('click', function() {
    $('.mobile-menu').stop().animate({
      left: '-100%'
    }, 400, function() {
      $('body').removeClass('overflow-hidden');
    });
    return false;
  });
  $('.mobile-menu-back').on('click', function() {
    var openedMenu = $(this).parent();
    openedMenu.stop().animate({
      left: '100%'
    }, 400);
    $('.mobile-menu-main').stop().animate({
      left: 0
    }, 400);
    return false;
  });
  $('.mobile-menu a[data-menu]').on('click', function() {
    var openedMenu = $(this).parent();
    var selectedMenu = $('.mobile-menu-sub[data-submenu="' + $(this).data('menu') + '"]');
    if (selectedMenu.length > 0) {
      openedMenu.stop().animate({
        left: '-100%'
      }, 400);
      selectedMenu.stop().animate({
        left: 0
      }, 400);
      return false;
    }
  });
  $('.main-menu .link-level-1').hover(function() {
    var $this = $(this);
    var level2 = $('ul', $this);
    if (level2.length > 0) {
      level2.stop().slideDown(250);
    }
  }, function() {
	var $this = $(this);
    var level2 = $('ul', $this);
    if (level2.length > 0) {
      level2.stop().slideUp(250);
    }
  });
  var menuTimer;
  $('.main-menu a[data-megamenu]').hover(function() {
    clearTimeout(menuTimer);
    var selectedMenu = $(this).data('megamenu');
    var megaMenu = $('.main-menu .menu-mega[data-megamenu="' + selectedMenu + '"]');
    if (megaMenu.length > 0) {
      megaMenu.stop().slideDown(250); 
    }
  }, function() {
    var selectedMenu = $(this).data('megamenu');
    var megaMenu = $('.main-menu .menu-mega[data-megamenu="' + selectedMenu + '"]');
    menuTimer = setTimeout(function() {
      if (!megaMenu.is(':hover')) {
        megaMenu.stop().slideUp(250);
      }
    }, 250);
  });
  $('.main-menu .menu-mega[data-megamenu]').on('mouseleave', function() {
    var $this = $(this);
	var selectedMenu = $(this).data('megamenu');
    var megaMenu = $('.main-menu a[data-megamenu="' + selectedMenu + '"]');
    menuTimer = setTimeout(function() {
      if (!megaMenu.is(':hover')) {
        $this.stop().slideUp(250);
      }
    }, 250);
  });

  $('.header__icon--cart').on('click', function() {
    $('body').addClass('cart--drawer-opened');
    $('.section-announcement-bar').height($('.announcement-bar-line').height());
    $('.cart--drawer').stop().animate({
      right: 0
    }, 400);
    return false;
  });
  
  $('.header__icon--search').on('click', function() {
	$('.header-search').stop().fadeIn(200);
    return false;
  });
  $('.modal__close-button').on('click', function() {
    $('.header-search').stop().fadeOut(200);
    return false;
  });

  $('.cart--drawer-close').on('click', function() {
    $('.cart--drawer').stop().animate({
      right: '-100%'
    }, 400, function() {
      $('body').removeClass('cart--drawer-opened');
    });
    return false;
  });

  $(document).on('click', '.quantity-plus', function() {
    var input = $('input', $(this).closest('div'));
    var qty = parseInt(input.val()) + 1;

    input.val(qty);

    var product = $(this).closest('.cart--drawer-product');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates[' + product.data('product-variant-id') + ']=' + qty,
      dataType: 'json',
      success: function(data) {
        var total_price = data.total_price / 100;
        var total = Intl.NumberFormat(Shopify.locale, {
          style: 'currency',
          currency: Shopify.currency.active
        }).format(total_price);
        $('.cart--drawer-summary-subtotal').text(total);

        var shipping = 'Free';
        if (total_price < free_shipping) {
          shipping = 'Calculated at checkout';

          $('.cart--drawer-free-shipping-success').removeClass('show');
          $('.cart--drawer-free-shipping').removeClass('hide');
          if ($('.announcement-bar-line').length > 0) {
            $('.announcement-bar-text-success').removeClass('show');
            $('.announcement-bar-text').removeClass('hide');
          }

          $('.cart--drawer-process-bar div').animate({
            'width': (100 - (((free_shipping - total_price) * 100) / free_shipping)) + '%'
          }, 500);
          if ($('.section-announcement-bar').length > 0) {
            $('.announcement-bar-progress-bar div').animate({
              'width': (100 - (((free_shipping - total_price) * 100) / free_shipping)) + '%'
            }, 500);
          }

          var freeShippingPriceLeft = Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active
          }).format((free_shipping - total_price));
          $('.cart--drawer-free-shipping .money').text(freeShippingPriceLeft);
          if ($('.section-announcement-bar').length > 0) {
            $('.announcement-bar-text .money').text(freeShippingPriceLeft);
          }
        } else {
          $('.cart--drawer-free-shipping').addClass('hide');
          $('.cart--drawer-free-shipping-success').addClass('show');
          if ($('.announcement-bar-line').length > 0) {
            $('.announcement-bar-text').addClass('hide');
            $('.announcement-bar-text-success').addClass('show');
          }

          $('.cart--drawer-process-bar div').animate({
            'width': '100%'
          }, 500);
          var freeShippingPriceLeft = Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active
          }).format((free_shipping - total_price));
          $('.cart--drawer-free-shipping .money').text(freeShippingPriceLeft);
          if ($('.section-announcement-bar').length > 0) {
            $('.announcement-bar-progress-bar div').animate({
              'width': '100%'
            }, 500);
          }
        }
        $('.cart--drawer-summary-shipping').text(shipping);

        //$('.cart-count-bubble span[aria-hidden="true"], .mobile-nav-bar a span, .cart--drawer-count').text(data.item_count);
        //$('.cart-count-bubble span.visually-hidden').text(data.item_count + ' items');
      }
    });
  });
  $(document).on('click', '.quantity-minus', function() {
    var input = $('input', $(this).closest('div'));
    var qty = parseInt(input.val()) - 1;

    input.val(qty);

    var product = $(this).closest('.cart--drawer-product');
    if (qty <= 0) {
      product.remove();
    }
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates[' + product.data('product-variant-id') + ']=' + qty,
      dataType: 'json',
      success: function(data) {
        var total_price = data.total_price / 100;
        var total = Intl.NumberFormat(Shopify.locale, {
          style: 'currency',
          currency: Shopify.currency.active
        }).format(total_price);
        $('.cart--drawer-summary-subtotal').text(total);

        var shipping = 'Free';
        if (total_price < free_shipping) {
          shipping = 'Calculated at checkout';

          $('.cart--drawer-free-shipping-success').removeClass('show');
          $('.cart--drawer-free-shipping').removeClass('hide');
          if ($('.announcement-bar-line').length > 0) {
            $('.announcement-bar-text-success').removeClass('show');
            $('.announcement-bar-text').removeClass('hide');
          }

          $('.cart--drawer-process-bar div').animate({
            'width': (100 - (((free_shipping - total_price) * 100) / free_shipping)) + '%'
          }, 500);
          if ($('.section-announcement-bar').length > 0) {
            $('.announcement-bar-progress-bar div').animate({
              'width': (100 - (((free_shipping - total_price) * 100) / free_shipping)) + '%'
            }, 500);
          }

          var freeShippingPriceLeft = Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active
          }).format((free_shipping - total_price));
          $('.cart--drawer-free-shipping .money').text(freeShippingPriceLeft);
          if ($('.section-announcement-bar').length > 0) {
            $('.announcement-bar-text .money').text(freeShippingPriceLeft);
          }
        }
        $('.cart--drawer-summary-shipping').text(shipping);

        if (data.item_count > 0) {
          //$('.cart-count-bubble span[aria-hidden="true"]').text(data.item_count);
          //$('.cart-count-bubble span.visually-hidden').text(data.item_count + ' ' + (data.item_count == 1 ? 'item' : 'items'));
        } else {
          if ($('.cart--drawer-you-may-also-like').length > 0 && !$('.cart--drawer-you-may-also-like').hasClass('hidden')) {
			$('.cart--drawer-you-may-also-like, .cart--drawer-you-may-also-like-title').addClass('hidden');
		  }
          //$('.header__icon--cart svg, .cart-count-bubble').remove();
          //$('.header__icon--cart').prepend('<svg class="icon icon-cart-empty" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path d="m15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.78-11.61zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1 -9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z" fill="currentColor" fill-rule="evenodd"/></svg>');
          $('.mobile-nav-bar a span').addClass('hidden');
        }
        $('.mobile-nav-bar a span, .cart--drawer-count').text(data.item_count);
      }
    });
  });

  $('.select2').select2();

  $(document).on('click', '.cart--drawer-product-remove', function() {
    var product = $(this).closest('.cart--drawer-product');
    product.remove();
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates[' + product.data('product-variant-id') + ']=0',
      dataType: 'json',
      success: function(data) {
        var total_price = data.total_price / 100;
        var total = Intl.NumberFormat(Shopify.locale, {
          style: 'currency',
          currency: Shopify.currency.active
        }).format(total_price);
        $('.cart--drawer-summary-subtotal').text(total);

        var shipping = 'Free';
        if (total_price < free_shipping) {
          shipping = 'Calculated at checkout';

          $('.cart--drawer-free-shipping-success').removeClass('show');
          $('.cart--drawer-free-shipping').removeClass('hide');
          if ($('.announcement-bar-line').length > 0) {
            $('.announcement-bar-text-success').removeClass('show');
            $('.announcement-bar-text').removeClass('hide');
          }

          $('.cart--drawer-process-bar div').animate({
            'width': (100 - (((free_shipping - total_price) * 100) / free_shipping)) + '%'
          }, 500);
          if ($('.section-announcement-bar').length > 0) {
            $('.announcement-bar-progress-bar div').animate({
              'width': (100 - (((free_shipping - total_price) * 100) / free_shipping)) + '%'
            }, 500);
          }

          var freeShippingPriceLeft = Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active
          }).format((free_shipping - total_price));
          $('.cart--drawer-free-shipping .money').text(freeShippingPriceLeft);
          if ($('.section-announcement-bar').length > 0) {
            $('.announcement-bar-text .money').text(freeShippingPriceLeft);
          }
        }
        $('.cart--drawer-summary-shipping').text(shipping);

        if (data.item_count > 0) {
          //$('.cart-count-bubble span[aria-hidden="true"]').text(data.item_count);
          //$('.cart-count-bubble span.visually-hidden').text(data.item_count + ' ' + (data.item_count == 1 ? 'item' : 'items'));
        } else {
          if ($('.cart--drawer-you-may-also-like').length > 0 && !$('.cart--drawer-you-may-also-like').hasClass('hidden')) {
			$('.cart--drawer-you-may-also-like, .cart--drawer-you-may-also-like-title').addClass('hidden');
		  }
          //$('.header__icon--cart svg, .cart-count-bubble').remove();
          //$('.header__icon--cart').prepend('<svg class="icon icon-cart-empty" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path d="m15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.78-11.61zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1 -9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z" fill="currentColor" fill-rule="evenodd"/></svg>');
          $('.mobile-nav-bar a span').addClass('hidden');
        }
        $('.mobile-nav-bar a span, .cart--drawer-count').text(data.item_count);
      }
    });
    return false;
  });

  $(document).on('click', '[data-add-id]', function() {
    var button = $(this);
    var select = $('select.select__select', button.closest('.card-wrapper'));
    if (select.length > 0) {
      var variant_id = select.val();
    } else {
      var variant_id = button.data('add-id');
      var quantity = button.data('add-quantity');
    }
    if (quantity == undefined) {
      quantity = 1;
    }
    $('span', button).addClass('hidden');
    $('.loading-overlay__spinner', button).removeClass('hidden');
    if (button.hasClass('buy-now')) {
      $.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        success: function() {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              id: variant_id,
              quantity: 1
            },
            dataType: 'json',
            success: function() {
              window.location.href = '/checkout';
            }
          });
        }
      });
    } else {
      addProduct(variant_id, quantity);
      setTimeout(function() {
        $('.loading-overlay__spinner', button).addClass('hidden');
        $('span', button).removeClass('hidden');
        if (!$('body').hasClass('cart--drawer-opened')) {
          $('body').addClass('cart--drawer-opened');
          $('.cart--drawer').animate({
            right: 0
          }, 500);
        }
      }, 500);
    }
    return false;
  });

  $('button[name="add"]').on('click', function() {
    var button = $(this);
    var form = button.closest('form');
    var upsell = $('.upsell-product [name="upsell"]');
    var variant_id = $('[name="id"]', form).val();
    var selling_plan = $('.product__info-container .paywhirl-plan-selector [name="selling_plan"]').val();
    var quantity = $('quantity-input [name="quantity"]').val();
    if (quantity == undefined || quantity <= 0) {
      quantity = 1;
    }
    $('span', button).addClass('hidden');
    $('.loading-overlay__spinner', button).removeClass('hidden');
    var items = [];
    if (upsell.is(':checked') == true) {
      items = [
        {
          quantity: quantity,
          id: variant_id,
          selling_plan: selling_plan
        },
        {
          quantity: 1,
          id: upsell.val()
        }
      ];
    } else {
      items = [
        {
          quantity: quantity,
          id: variant_id,
          selling_plan: selling_plan
        }
      ];
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: items
      },
      dataType: 'json',
      success: function() {
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(data) {
            var pro_id = 0;
            $.each(data.items, function(k, v) {
              if (variant_id == v.variant_id) {
                pro_id = v.product_id;
              }
              var cartProduct = $('.cart--drawer-product[data-product-variant-id="' + v.variant_id + '"]');
              if (cartProduct.length > 0) {
                $('input[name="quantity"]', cartProduct).val(v.quantity);
              } else {
                var product_price = Intl.NumberFormat(Shopify.locale, {
                  style: 'currency',
                  currency: Shopify.currency.active
                }).format((v.price / 100));
                $('.cart--drawer-products').prepend('<div class="cart--drawer-product" data-product-variant-id="' + v.variant_id + '">\
                  <div class="cart--drawer-product-image">\
                    <a href="' + v.url + '">\
                      <img src="' + v.image + '" alt="' + v.title + '">\
                    </a>\
                  </div>\
                  <div class="cart--drawer-product-info">\
                    <a href="/cart/change?id=' + v.key + '&amp;quantity=0" class="cart--drawer-product-remove">\
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\
                        <path d="M11.89 6.7L10 8.59L8.11 6.7C7.72 6.31 7.09 6.31 6.7 6.7C6.31 7.09 6.31 7.72 6.7 8.11L8.59 10L6.7 11.89C6.31 12.28 6.31 12.91 6.7 13.3C7.09 13.69 7.72 13.69 8.11 13.3L10 11.41L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L11.41 10L13.3 8.11C13.69 7.72 13.69 7.09 13.3 6.7C12.91 6.32 12.27 6.32 11.89 6.7ZM10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="black"></path>\
                      </svg>\
                    </a>\
                    <div class="cart--drawer-product-name">\
                      <a href="' + v.url + '">' + v.title + '</a>\
                    </div>\
                    <div class="cart--drawer-product-price">' + product_price + '</div>\
                    <div class="cart--drawer-product-quantity">\
                      <div>Quantity</div>\
                      <div>\
                        <button type="button" class="quantity-minus">\
                          <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">\
                            <path d="M8.99992 1.66683H0.999919C0.633252 1.66683 0.333252 1.36683 0.333252 1.00016C0.333252 0.633496 0.633252 0.333496 0.999919 0.333496H8.99992C9.36659 0.333496 9.66659 0.633496 9.66659 1.00016C9.66659 1.36683 9.36659 1.66683 8.99992 1.66683Z" fill="black"></path>\
                          </svg>\
                        </button>\
                        <input type="text" name="quantity" value="' + v.quantity + '" min="1" readonly="readonly">\
                        <button type="button" class="quantity-plus">\
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">\
                            <path d="M8.99992 5.66683H5.66659V9.00016C5.66659 9.36683 5.36659 9.66683 4.99992 9.66683C4.63325 9.66683 4.33325 9.36683 4.33325 9.00016V5.66683H0.999919C0.633252 5.66683 0.333252 5.36683 0.333252 5.00016C0.333252 4.6335 0.633252 4.3335 0.999919 4.3335H4.33325V1.00016C4.33325 0.633496 4.63325 0.333496 4.99992 0.333496C5.36659 0.333496 5.66659 0.633496 5.66659 1.00016V4.3335H8.99992C9.36659 4.3335 9.66659 4.6335 9.66659 5.00016C9.66659 5.36683 9.36659 5.66683 8.99992 5.66683Z" fill="black"></path>\
                          </svg>\
                        </button>\
                      </div>\
                    </div>\
                  </div>\
                </div>');
              }
            });

            var total_price = data.total_price / 100;
            var total = Intl.NumberFormat(Shopify.locale, {
              style: 'currency',
              currency: Shopify.currency.active
            }).format(total_price);
            $('.cart--drawer-summary-subtotal').text(total);

            var shipping = 'Free';
            if (total_price < free_shipping) {
              shipping = 'Calculated at checkout';

              $('.cart--drawer-free-shipping-success').removeClass('show');
              $('.cart--drawer-free-shipping').removeClass('hide');
              if ($('.announcement-bar-line').length > 0) {
                $('.announcement-bar-text-success').removeClass('show');
                $('.announcement-bar-text').removeClass('hide');
              }

              $('.cart--drawer-process-bar div').animate({
                'width': (100 - (((free_shipping - total_price) * 100) / free_shipping)) + '%'
              }, 500);
              if ($('.section-announcement-bar').length > 0) {
                $('.announcement-bar-progress-bar div').animate({
                  'width': (100 - (((free_shipping - total_price) * 100) / free_shipping)) + '%'
                }, 500);
              }
            } else {
              $('.cart--drawer-free-shipping').addClass('hide');
              $('.cart--drawer-free-shipping-success').addClass('show');
              if ($('.announcement-bar-line').length > 0) {
                $('.announcement-bar-text').addClass('hide');
                $('.announcement-bar-text-success').addClass('show');
              }

              $('.cart--drawer-process-bar div').animate({
                'width': '100%'
              }, 500);
              if ($('.section-announcement-bar').length > 0) {
                $('.announcement-bar-progress-bar div').animate({
                  'width': '100%'
                }, 500);
              }
            }

            var freeShippingPriceLeft = Intl.NumberFormat(Shopify.locale, {
              style: 'currency',
              currency: Shopify.currency.active
            }).format((free_shipping - total_price));
            $('.cart--drawer-free-shipping .money').text(freeShippingPriceLeft);
            if ($('.section-announcement-bar').length > 0) {
              $('.announcement-bar-text .money').text(freeShippingPriceLeft);
            }
            $('.cart--drawer-summary-shipping').text(shipping);

            if (data.item_count == 1) {
              //$('.header__icon--cart svg').remove();
              //$('.header__icon--cart').prepend('<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path></svg>');
              //$('.header__icon--cart').append('<div class="cart-count-bubble"><span aria-hidden="true">' + quantity + '</span><span class="visually-hidden">' + quantity + ' ' + (quantity > 1 ? 'items' : 'item') + '</span></div>');
            } else if (data.item_count > 0) {
              //$('.cart-count-bubble span[aria-hidden="true"]').text(data.item_count);
              //$('.cart-count-bubble span.visually-hidden').text(data.item_count + ' ' + (data.item_count == 1 ? 'item' : 'items'));
            }
            $('.mobile-nav-bar a span, .cart--drawer-count').text(data.item_count);
            $('.mobile-nav-bar a span.hidden').removeClass('hidden');

            if ($('.cart--drawer-you-may-also-like').length > 0) {
              if ($('.cart--drawer-you-may-also-like').hasClass('hidden')) {
                $('.cart--drawer-you-may-also-like, .cart--drawer-you-may-also-like-title').removeClass('hidden');
              }
              $('.cart--drawer-you-may-also-like-scroller .swiper-wrapper').text('');
              if ($('.cart--drawer-you-may-also-like').data('shopify-recommendations') == true) {
                $.get('/recommendations/products.json?product_id=' + pro_id, function(results) {
                  $.each(results.products, function(k, v) {
                    var exist = false;
                    $.each(v.variants, function(k2, v2) {
                      if ($('.cart--drawer-product[data-product-variant-id="' + v2.id + '"]').length > 0 && exist == false) {
                        exist = true;
                      }
                    });
                    if (exist == false) {
                      var product_price = Intl.NumberFormat(Shopify.locale, {
                        style: 'currency',
                        currency: Shopify.currency.active
                      }).format((v.price / 100));
                      $('.cart--drawer-you-may-also-like-scroller .swiper-wrapper').append('<div class="swiper-slide cart--drawer-product-big" data-product-id="' + v.variant_id + '">\
                        <a href="/products/' + v.handle + '">\
                          <img src="' + v.featured_image + '" alt="' + v.title + '">\
                          <div class="cart--drawer-product-big-name">' + v.title + '</div>\
                        </a>\
                        <button type="button" class="cart--drawer-product-big-button" data-add-id="' + v.variants[0].id + '">\
                          <span>Add to Cart • ' + product_price + '</span>\
                          <div class="loading-overlay__spinner hidden">\
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                            </svg>\
                          </div>\
                        </button>\
                      </div>');
                    }
                  });
                  new Swiper('.cart--drawer-you-may-also-like-scroller', {
                    slidesPerView: 'auto',
                    spaceBetween: 12,
                    freeMode: true,
                    mousewheel: {
                      forceToAxis: true
                    }
                  });
                });
              } else {
                var i = 1;
                $.each(products, function(k, v) {
                  if (i < 5) {
                    var exist = false;
                    $.each(v.variants, function(k2, v2) {
                      if ($('.cart--drawer-product[data-product-variant-id="' + v2.id + '"]').length > 0 && exist == false) {
                        exist = true;
                      }
                    });
                    if (exist == false) {
                      var product_price = Intl.NumberFormat(Shopify.locale, {
                        style: 'currency',
                        currency: Shopify.currency.active
                      }).format((v.price / 100));
                      $('.cart--drawer-you-may-also-like-scroller .swiper-wrapper').append('<div class="swiper-slide cart--drawer-product-big" data-product-id="' + v.variant_id + '">\
                        <a href="/products/' + v.handle + '">\
                          <img src="' + v.featured_image + '" alt="' + v.title + '">\
                          <div class="cart--drawer-product-big-name">' + v.title + '</div>\
                        </a>\
                        <button type="button" class="cart--drawer-product-big-button" data-add-id="' + v.variants[0].id + '">\
                          <span>Add to Cart • ' + product_price + '</span>\
                          <div class="loading-overlay__spinner hidden">\
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                            </svg>\
                          </div>\
                        </button>\
                      </div>');
                      i++;
                    }
                  }
                });
                new Swiper('.cart--drawer-you-may-also-like-scroller', {
                  slidesPerView: 'auto',
                  spaceBetween: 12,
                  freeMode: true,
                  mousewheel: {
                    forceToAxis: true
                  }
                });
              }
            }

            setTimeout(function() {
              $('.loading-overlay__spinner', button).addClass('hidden');
              $('span', button).removeClass('hidden');
              $('body').addClass('cart--drawer-opened');
              $('.cart--drawer').animate({
                right: 0
              }, 500);
            }, 500);
          }
        });
      }
    });
    return false;
  });

  $('.section-add-to-cart-bar .button').on('click', function() {
    $('.product-form__buttons .product-form__submit').trigger('click');
    return false;
  });

  $('.section-reasons-to-love .image-texts .texts a[data-tab]').on('click', function() {
    var link = $(this);
    if (!link.hasClass('active')) {
      var tab = link.data('tab');
      $('.section-reasons-to-love .image-texts .texts a[data-tab].active, .section-reasons-to-love .dots a.active').removeClass('active');
      link.addClass('active');
      $('.section-reasons-to-love .image-texts .image img:not(.hidden)').addClass('hidden');
      $('.section-reasons-to-love .image-texts .image img[data-tab="' + tab + '"]').removeClass('hidden');
      $('.section-reasons-to-love .dots a[data-tab="' + tab + '"]').addClass('active');
    }
    return false;
  });
  $('.section-reasons-to-love .dots a').on('click', function() {
    var tab = $(this).data('tab');
    if (!$(this).hasClass('active')) {
      $('.section-reasons-to-love .image-texts .texts a[data-tab].active, .section-reasons-to-love .dots a.active').removeClass('active');
      $(this).addClass('active');
      $('.section-reasons-to-love .image-texts .image img:not(.hidden)').addClass('hidden');
      $('.section-reasons-to-love .image-texts .image img[data-tab="' + tab + '"]').removeClass('hidden');
      $('.section-reasons-to-love .image-texts .texts a[data-tab="' + tab + '"]').addClass('active');
    }
    return false;
  });

  $('.section-faq .faqs .faq .faq-question').on('click', function() {
    var faq = $(this).closest('.faq');
    if (faq.hasClass('active')) {
      faq.removeClass('active');
    } else {
      $('.section-faq .faqs .faq.active').removeClass('active');
      faq.addClass('active');
    }
  });

  $('.section-featured-reviews .featured-reviews-content .featured-reviews-button a.button').on('click', function() {
    var reviews = $('.section-featured-reviews .yotpo');
    if (reviews.hasClass('hidden')) {
      reviews.removeClass('hidden');
      $(this).text('Show less reviews');
    } else {
      reviews.addClass('hidden');
      $(this).text('Show more reviews');
    }
    return false;
  });

  $('.mobile-nav-bar a[href="/search"]').on('click', function() {
    $('body').addClass('overflow-hidden');
    $('.header__search details').attr('open', 'true');
    return false
  });
  $('.mobile-nav-bar button').on('click', function() {
    var button = $(this);
    var variant_id = $('.product-form [name="id"]').val();
    var quantity = $('.quantity [name="quantity"]').val();
    if (quantity == undefined) {
      quantity = 1;
    }
    if (parseInt(variant_id) > 0) {
      $('span', button).addClass('hidden');
      $('.loading-overlay__spinner', button).removeClass('hidden');
      addProduct(variant_id, quantity);
      setTimeout(function() {
        $('.loading-overlay__spinner', button).addClass('hidden');
        $('span', button).removeClass('hidden');
        $('body').addClass('cart--drawer-opened');
        $('.cart--drawer').animate({
          right: 0
        }, 500);
        $('.mobile-nav-bar.product-nav-bar').stop().animate({
          'bottom': '-64px'
        }, 250, function() {
          $('.mobile-nav-bar.product-nav-bar').addClass('fixed');
          $('.mobile-nav-bar.product-nav-bar button').addClass('hidden');
          $('.mobile-nav-bar.product-nav-bar div').show();
          $('.mobile-nav-bar.product-nav-bar').stop().animate({
            'bottom': '24px'
          }, 250)
        });
      }, 500);
    }
  });

  var scrollTop = $(window).scrollTop();
  if ($('.mobile-nav-bar.product-nav-bar').length > 0) {
    var productNavBarShow = false;
    var elementOffsetProductNavBar = $('.product-form').offset().top;
    var distanceProductNavbar = (elementOffsetProductNavBar - scrollTop);
    if (distanceProductNavbar <= 0 && productNavBarShow == false) {
      $('.mobile-nav-bar.product-nav-bar').stop().animate({
        'bottom': '24px'
      }, 250);
      productNavBarShow = true;
    }
  }
  $(window).on('resize', function() {
    scrollTop = $(window).scrollTop();

    if ($('.mobile-nav-bar.product-nav-bar').length > 0) {
      elementOffsetProductNavBar = $('.product-form').offset().top;
      distanceProductNavbar = (elementOffsetProductNavBar - scrollTop);
      if (distanceProductNavbar <= 0 && productNavBarShow == false) {
        $('.mobile-nav-bar.product-nav-bar').stop().animate({
          'bottom': '24px'
        }, 250);
        productNavBarShow = true;
      } else if (distanceProductNavbar > 0 && productNavBarShow == true) {
        $('.mobile-nav-bar.product-nav-bar').stop().animate({
          'bottom': '-64px'
        }, 250);
        productNavBarShow = false;
      }
    }
  });
  $(window).on('scroll', function() {
    scrollTop = $(window).scrollTop();

    if ($('.mobile-nav-bar.product-nav-bar').length > 0) {
      elementOffsetProductNavBar = $('.product-form').offset().top;
      distanceProductNavbar = (elementOffsetProductNavBar - scrollTop);
      if (distanceProductNavbar <= 0 && productNavBarShow == false) {
        $('.mobile-nav-bar.product-nav-bar').stop().animate({
          'bottom': '24px'
        }, 250);
        productNavBarShow = true;
      } else if (distanceProductNavbar > 0 && productNavBarShow == true) {
        $('.mobile-nav-bar.product-nav-bar').stop().animate({
          'bottom': '-64px'
        }, 250);
        productNavBarShow = false;
      }
    }
  });

  $('.section-add-to-cart-bar').css('height', $('.section-add-to-cart-bar').height());
  if ($('.section-add-to-cart-bar').length > 0) {
    $('.section-add-to-cart-bar .add-to-cart-bar-line').sticky({
      topSpacing: 0
    });
  }

  $('.collection-filters a').on('click', function() {
    $('.collection-filters-bar').slideToggle('normal');
    return false;
  });
  $('.collection-sort a').on('click', function() {
    $('.collection-sort-bar').slideToggle('normal');
    return false;
  });

  $('.collection-line .collection-filters-bar .collection-filters-tab .collection-filters-tab-heading').on('click', function() {
    var tab = $(this).closest('.collection-filters-tab');
    tab.toggleClass('open');
    $('.collection-filters-tab-content', tab).slideToggle('normal');
  });
  $('.collection-line .collection-filters-bar .collection-filters-tab .collection-filters-tab-content .collection-filters-tab-content-value').on('click', function() {
    var checkbox = $('.checkbox', $(this));
    checkbox.toggleClass('checked');
  });
  $('.collection-filters-bar .apply-filters').on('click', function() {
    var sort_by = '';
    if (window.location.href.indexOf('sort_by=') != -1) {
      var match = window.location.href.match(/sort_by=([^&]+)/);
      if (match != null) {
      	sort_by = match[1];
      }
    }
    var uri = collection_uri + '?sort_by=' + sort_by + '&filter.v.price.gte=' + $('.filter-min-price').val() + '&filter.v.price.lte=' + $('.filter-max-price').val();
    var checked = $('.collection-filters-bar .checkbox.checked');
    $.each(checked, function(k, v) {
      var filter = $(v).closest('.collection-filters-tab-content-value');
      uri += '&' + filter.data('param') + '=' + filter.data('value');
    });
    window.location.href = uri;
    return false;
  });

  if ($('#price-range').length > 0) {
    $('#price-range').slider({
      range: true,
      min: $('#price-range').data('min'),
      max: $('#price-range').data('max'),
      values: [$('#price-range').data('current-min'), $('#price-range').data('current-max')],
      slide: function(event, ui) {
        $('.collection-filters-prices .collection-filters-prices-input:first-child input').val(ui.values[0]);
        $('.collection-filters-prices .collection-filters-prices-input:last-child input').val(ui.values[1]);
      }
    });
    $('.collection-filters-prices .collection-filters-prices-input:first-child input').val($('#price-range').slider('values', 0));
    $('.collection-filters-prices .collection-filters-prices-input:last-child input').val($('#price-range').slider('values', 1));
  }

  if ($('.cart--drawer-you-may-also-like-scroller').length > 0) {
    new Swiper('.cart--drawer-you-may-also-like-scroller', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: true,
      mousewheel: {
        forceToAxis: true
      }
    });
  }

  if ($('.product__images-thumbnails').length > 0) {
    var swiperMedia = new Swiper('.swiper-media', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: true,
      mousewheel: {
        forceToAxis: true
      },
      breakpoints: {
        990: {
          slidesPerView: 1,
          spaceBetween: 0,
          freeMode: false,
          mousewheel: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }
        }
      }
    });
    swiperMedia.on('slideChange', function() {
      var index = swiperMedia.realIndex + 1;
      $('.product__images-thumbnails a').removeClass('active');
      $('.product__images-thumbnails a[data-index="' + index + '"]').addClass('active');
    });

    $('.product__images-thumbnails a').on('click', function() {
      var thumb = $(this);
      if (!thumb.hasClass('active')) {
        $('.product__images-thumbnails a').removeClass('active');
        thumb.addClass('active');
        var index = parseInt(thumb.data('index')) - 1;
        swiperMedia.slideTo(index);
      }
      return false;
    });
  }

  $('.card-wrapper .card-wrapper-option select').on('change', function() {
    var $this = $(this);
    var cardWrapper = $this.closest('.card-wrapper');
    $('button', cardWrapper).attr('data-add-id', $this.val());
  });

  $('.section-add-to-cart-bar .links a').on('click', function() {
    var href = $(this).attr('href');
    if (href == '#start') {
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
      return false;
    } else if (href.indexOf('#') != -1 && $(href).length > 0) {
      $('html, body').animate({
        scrollTop: ($(href).offset().top - 72)
      }, 1000);
      return false;
    }
  });

  $('details-disclosure').hover(function() {
    var item = $('.header__menu-item', $(this));
    var details = $('details', $(this));
    item.attr('aria-expanded', 'true');
    details.attr('open', '');
  }, function() {
    var item = $('.header__menu-item', $(this));
    var details = $('details', $(this));
    item.attr('aria-expanded', 'false');
    details.removeAttr('open');
  });
  
  var headerSticky = $('.header-sticky');
  if (headerSticky.length > 0) {
    $(window).scroll(function() {
      
    });
  }
  
});

function addProduct(variant_id, quantity) {
  if (variant_id > 0 && quantity > 0) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variant_id,
        quantity: quantity
      },
      dataType: 'json',
      success: function(pro) {
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(data) {
            $.each(data.items, function(k, v) {
              var cartProduct = $('.cart--drawer-product[data-product-variant-id="' + v.variant_id + '"]');
              if (cartProduct.length > 0) {
                $('input[name="quantity"]', cartProduct).val(v.quantity);
              } else {
                var product_price = Intl.NumberFormat(Shopify.locale, {
                  style: 'currency',
                  currency: Shopify.currency.active
                }).format((v.price / 100));
                $('.cart--drawer-products').prepend('<div class="cart--drawer-product" data-product-variant-id="' + v.variant_id + '">\
                  <div class="cart--drawer-product-image">\
                    <a href="' + v.url + '">\
                      <img src="' + v.image + '" alt="' + v.title + '">\
                    </a>\
                  </div>\
                  <div class="cart--drawer-product-info">\
                    <a href="/cart/change?id=' + v.key + '&amp;quantity=0" class="cart--drawer-product-remove">\
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\
                        <path d="M11.89 6.7L10 8.59L8.11 6.7C7.72 6.31 7.09 6.31 6.7 6.7C6.31 7.09 6.31 7.72 6.7 8.11L8.59 10L6.7 11.89C6.31 12.28 6.31 12.91 6.7 13.3C7.09 13.69 7.72 13.69 8.11 13.3L10 11.41L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L11.41 10L13.3 8.11C13.69 7.72 13.69 7.09 13.3 6.7C12.91 6.32 12.27 6.32 11.89 6.7ZM10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="black"></path>\
                      </svg>\
                    </a>\
                    <div class="cart--drawer-product-name">\
                      <a href="' + v.url + '">' + v.title + '</a>\
                    </div>\
                    <div class="cart--drawer-product-price">' + product_price + '</div>\
                    <div class="cart--drawer-product-quantity">\
                      <div>Quantity</div>\
                      <div>\
                        <button type="button" class="quantity-minus">\
                          <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">\
                            <path d="M8.99992 1.66683H0.999919C0.633252 1.66683 0.333252 1.36683 0.333252 1.00016C0.333252 0.633496 0.633252 0.333496 0.999919 0.333496H8.99992C9.36659 0.333496 9.66659 0.633496 9.66659 1.00016C9.66659 1.36683 9.36659 1.66683 8.99992 1.66683Z" fill="black"></path>\
                          </svg>\
                        </button>\
                        <input type="text" name="quantity" value="' + quantity + '" min="1" readonly="readonly">\
                        <button type="button" class="quantity-plus">\
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">\
                            <path d="M8.99992 5.66683H5.66659V9.00016C5.66659 9.36683 5.36659 9.66683 4.99992 9.66683C4.63325 9.66683 4.33325 9.36683 4.33325 9.00016V5.66683H0.999919C0.633252 5.66683 0.333252 5.36683 0.333252 5.00016C0.333252 4.6335 0.633252 4.3335 0.999919 4.3335H4.33325V1.00016C4.33325 0.633496 4.63325 0.333496 4.99992 0.333496C5.36659 0.333496 5.66659 0.633496 5.66659 1.00016V4.3335H8.99992C9.36659 4.3335 9.66659 4.6335 9.66659 5.00016C9.66659 5.36683 9.36659 5.66683 8.99992 5.66683Z" fill="black"></path>\
                          </svg>\
                        </button>\
                      </div>\
                    </div>\
                  </div>\
                </div>');
              }
            });

            var total_price = data.total_price / 100;
            var total = Intl.NumberFormat(Shopify.locale, {
              style: 'currency',
              currency: Shopify.currency.active
            }).format(total_price);
            $('.cart--drawer-summary-subtotal').text(total);

            var shipping = 'Free';
            if (total_price < free_shipping) {
              shipping = 'Calculated at checkout';

              $('.cart--drawer-free-shipping-success').removeClass('show');
              $('.cart--drawer-free-shipping').removeClass('hide');
              if ($('.announcement-bar-line').length > 0) {
                $('.announcement-bar-text-success').removeClass('show');
                $('.announcement-bar-text').removeClass('hide');
              }

              $('.cart--drawer-process-bar div').animate({
                'width': (100 - (((free_shipping - total_price) * 100) / free_shipping)) + '%'
              }, 500);
              if ($('.section-announcement-bar').length > 0) {
                $('.announcement-bar-progress-bar div').animate({
                  'width': (100 - (((free_shipping - total_price) * 100) / free_shipping)) + '%'
                }, 500);
              }
            } else {
              $('.cart--drawer-free-shipping').addClass('hide');
              $('.cart--drawer-free-shipping-success').addClass('show');
              if ($('.announcement-bar-line').length > 0) {
                $('.announcement-bar-text').addClass('hide');
                $('.announcement-bar-text-success').addClass('show');
              }

              $('.cart--drawer-process-bar div').animate({
                'width': '100%'
              }, 500);
              if ($('.section-announcement-bar').length > 0) {
                $('.announcement-bar-progress-bar div').animate({
                  'width': '100%'
                }, 500);
              }
            }

            var freeShippingPriceLeft = Intl.NumberFormat(Shopify.locale, {
              style: 'currency',
              currency: Shopify.currency.active
            }).format((free_shipping - total_price));
            $('.cart--drawer-free-shipping .money').text(freeShippingPriceLeft);
            if ($('.section-announcement-bar').length > 0) {
              $('.announcement-bar-text .money').text(freeShippingPriceLeft);
            }
            $('.cart--drawer-summary-shipping').text(shipping);

            if (data.item_count == 1) {
              //$('.header__icon--cart svg').remove();
              //$('.header__icon--cart').prepend('<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path></svg>');
              //$('.header__icon--cart').append('<div class="cart-count-bubble"><span aria-hidden="true">' + quantity + '</span><span class="visually-hidden">' + quantity + ' ' + (quantity > 1 ? 'items' : 'item') + '</span></div>');
            } else if (data.item_count > 0) {
              $('.cart-count-bubble span[aria-hidden="true"]').text(data.item_count);
              $('.cart-count-bubble span.visually-hidden').text(data.item_count + ' ' + (data.item_count == 1 ? 'item' : 'items'));
            }
            $('.mobile-nav-bar a span, .cart--drawer-count').text(data.item_count);
            $('.mobile-nav-bar a span.hidden').removeClass('hidden');

            if ($('.cart--drawer-you-may-also-like').length > 0) {
              if ($('.cart--drawer-you-may-also-like').hasClass('hidden')) {
                $('.cart--drawer-you-may-also-like, .cart--drawer-you-may-also-like-title').removeClass('hidden');
              }
              $('.cart--drawer-you-may-also-like-scroller .swiper-wrapper').text('');
              if ($('.cart--drawer-you-may-also-like').data('shopify-recommendations') == true) {
                $.get('/recommendations/products.json?product_id=' + pro.product_id, function(results) {
                  $.each(results.products, function(k, v) {
                    var exist = false;
                    $.each(v.variants, function(k2, v2) {
                      if ($('.cart--drawer-product[data-product-variant-id="' + v2.id + '"]').length > 0 && exist == false) {
                        exist = true;
                      }
                    });
                    if (exist == false) {
                      var product_price = Intl.NumberFormat(Shopify.locale, {
                        style: 'currency',
                        currency: Shopify.currency.active
                      }).format((v.price / 100));
                      $('.cart--drawer-you-may-also-like-scroller .swiper-wrapper').append('<div class="swiper-slide cart--drawer-product-big" data-product-id="' + v.variant_id + '">\
                        <a href="/products/' + v.handle + '">\
                          <img src="' + v.featured_image + '" alt="' + v.title + '">\
                          <div class="cart--drawer-product-big-name">' + v.title + '</div>\
                        </a>\
                        <button type="button" class="cart--drawer-product-big-button" data-add-id="' + v.variants[0].id + '">\
                          <span>Add to Cart • ' + product_price + '</span>\
                          <div class="loading-overlay__spinner hidden">\
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                            </svg>\
                          </div>\
                        </button>\
                      </div>');
                    }
                  });
                  new Swiper('.cart--drawer-you-may-also-like-scroller', {
                    slidesPerView: 'auto',
                    spaceBetween: 12,
                    freeMode: true,
                    mousewheel: {
                      forceToAxis: true
                    }
                  });
                });
              } else {
                var i = 1;
                $.each(products, function(k, v) {
                  if (i < 5) {
                    var exist = false;
                    $.each(v.variants, function(k2, v2) {
                      if ($('.cart--drawer-product[data-product-variant-id="' + v2.id + '"]').length > 0 && exist == false) {
                        exist = true;
                      }
                    });
                    if (exist == false) {
                      var product_price = Intl.NumberFormat(Shopify.locale, {
                        style: 'currency',
                        currency: Shopify.currency.active
                      }).format((v.price / 100));
                      $('.cart--drawer-you-may-also-like-scroller .swiper-wrapper').append('<div class="swiper-slide cart--drawer-product-big" data-product-id="' + v.variant_id + '">\
                        <a href="/products/' + v.handle + '">\
                          <img src="' + v.featured_image + '" alt="' + v.title + '">\
                          <div class="cart--drawer-product-big-name">' + v.title + '</div>\
                        </a>\
                        <button type="button" class="cart--drawer-product-big-button" data-add-id="' + v.variants[0].id + '">\
                          <span>Add to Cart • ' + product_price + '</span>\
                          <div class="loading-overlay__spinner hidden">\
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                            </svg>\
                          </div>\
                        </button>\
                      </div>');
                      i++;
                    }
                  }
                });
                new Swiper('.cart--drawer-you-may-also-like-scroller', {
                  slidesPerView: 'auto',
                  spaceBetween: 12,
                  freeMode: true,
                  mousewheel: {
                    forceToAxis: true
                  }
                });
              }
            }
          }
        });
      }
    });
  }
}
